// extracted by mini-css-extract-plugin
module.exports = {"sign-up-info-modal__overlay":"SignUpInfoModal_sign-up-info-modal__overlay__0NtR6","sign-up-info-modal__button":"SignUpInfoModal_sign-up-info-modal__button__vGds_"};